export const WHATSAPP_URL = 'https://wa.me/5511918999148'

export const JOURNAL_WHATSAPP_DEFAULT_MESSAGE =
  'Olá! Acessei uma página de Diário Oficial no site do Jusbrasil e queria entender mais sobre os meus direitos.'

export const SEUS_DIREITOS_DEFAULT_MESSAGE = 'Olá, tenho dúvidas sobre os meus direitos'

export const SEUS_DIREITOS_ARTIGOS_MESSAGE =
  'Olá! Acabei de ler um artigo no Jusbrasil e queria entender quais são os meus direitos.'

export const SEUS_DIREITOS_NOTICIAS_MESSAGE =
  'Olá! Acabei de ler uma notícia no Jusbrasil e queria saber se algo parecido pode se aplicar ao meu caso.'

export const SD_CTA_VARIANTS_THAT_SHOW: string[] = ['variantA', 'variantB']
